export default {
  name: "NavbarSection",
};
